<ui-dialog width="sm" noDialogTitle noDialogActions>
  <ng-container dialog-content>
    <div class="flex flex-col gap-6 py-4">
      <p class="m-0 text-cp-primary-100">
        Willkommen in unserem neuen Kfz-Rechner! Wir haben den Rechner für dich
        überarbeitet. Deine bisherigen Angaben wurden, soweit möglich, übernommen. Bitte
        prüfe diese und ergänze fehlende Angaben.
      </p>
      <button mat-flat-button color="accent" class="btn-primary-lg w-full" (click)="close()">
        Verstanden
      </button>
    </div>
  </ng-container>
</ui-dialog>
